import {getDataWithPromise, Globals, handleAjaxError} from "./BaseDataFns";

/*
    get a list of surveys for either:

    1) A provider ID
    2) 'all' - Call will be rejected by the server if the logged on user is not system admin
    3) 'user' - Call will retrieve data for the providers the current user is managing
    3) 'current' - Call will retrieve data for the current user's provider

 */
export const getProviderSurveys = ( provider_id, onComplete ) =>
{
    const url = Globals.APIFolder + '/establishment/' + provider_id + '/surveys';

    getDataWithPromise ( url, 'GET', {} )
    .then (response =>
    {
        onComplete (response) ;
    })
    .catch( (jqXHR, textStatus, error) =>
    {
        handleAjaxError( jqXHR, textStatus, error) ;
    });
}

export const getProvidersForUser = ( user_id, onComplete ) =>
{
    const url = Globals.APIFolder + '/user/' + user_id + '/establishments';

    getDataWithPromise ( url, 'GET', {} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const getProviderDetails = ( enc_user_id, enc_provider_id, onComplete ) =>
{
    const url = Globals.APIFolder + '/user/' + enc_user_id + '/establishments/' + enc_provider_id + '/details' ;

    getDataWithPromise ( url, 'GET', {} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const getProviderUsers = ( enc_user_id, enc_provider_id, filter, onComplete ) =>
{
    const filterText = filter === null ? '' : '?filter=' + filter ;

    const url = Globals.APIFolder + '/user/' + enc_user_id + '/establishments/' + enc_provider_id + '/users' + filterText;

    getDataWithPromise ( url, 'GET', {} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const getProviderAuthorisedSurveyList = ( enc_provider_id, filter, onComplete ) =>
{
    const url = Globals.APIFolder + '/establishment/' + enc_provider_id + '/surveys/access' ;

    getDataWithPromise ( url, 'GET', {} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const createProviderStaff = ( enc_provider_id, data, onComplete ) =>
{
    const url = Globals.APIFolder + '/establishment/' + enc_provider_id + '/users' ;

    getDataWithPromise ( url, 'POST', data )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const updateProviderStaff = ( enc_provider_id, user_id, formdata, onComplete ) =>
{
    const url = Globals.APIFolder + '/establishment/' + enc_provider_id + '/users' ;

    formdata.user.user_id = user_id ;

    const updatePacket = {
        operation: 'update',
        data: formdata
    }

    getDataWithPromise ( url, 'PUT', updatePacket )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const resendProviderStaffInvite = ( enc_provider_id, user_id, formdata, onComplete ) =>
{
    const url = Globals.APIFolder + '/establishment/' + enc_provider_id + '/users' ;

    formdata.user.user_id = user_id ;

    const updatePacket = {
        operation: 'resend',
        data: formdata
    }

    getDataWithPromise ( url, 'PUT', updatePacket )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const deleteProviderStaff = ( enc_provider_id, user_id, formdata, onComplete ) =>
{
    const url = Globals.APIFolder + '/establishment/' + enc_provider_id + '/users' ;

    formdata.user.user_id = user_id ;

    const updatePacket = {
        operation: 'delete',
        data: formdata
    }

    getDataWithPromise ( url, 'PUT', updatePacket )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const promoteProviderStaff = ( enc_provider_id, user_id, formdata, onComplete ) =>
{
    const url = Globals.APIFolder + '/establishment/' + enc_provider_id + '/users' ;

    formdata.user.user_id = user_id ;

    const updatePacket = {
        operation: 'promote',
        data: formdata
    }

    getDataWithPromise ( url, 'PUT', updatePacket )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const getUserDetails = ( enc_provider_id, enc_user_id, onComplete ) =>
{
    const url = Globals.APIFolder + '/establishment/' + enc_provider_id + '/users/' + enc_user_id + '/details' ;

    getDataWithPromise ( url, 'GET', {} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const updateProviderDetails = ( provider_id, data, onComplete ) =>
{
    const url = Globals.APIFolder + '/establishment/' + provider_id + '/details' ;

    getDataWithPromise ( url, 'PUT', data )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const createNewProvider= ( data, onComplete ) =>
{
    const url = Globals.APIFolder + '/establishment' ;

    getDataWithPromise ( url, 'POST', data )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}
